import { VStack } from '@web/components/atoms/Layout'
import {
  DonationBackHeader,
  TermsAndConditions,
  useDonationFormContext,
} from '@web/components/page-components/DonationForm'
import PaymentButtons from '../PaymentButtons'
import DonationStepTabs from '@web/components/page-components/DonationForm/components/atoms/DonationStepTab'
import DonationAmountBanner from '@web/components/page-components/DonationForm/components/atoms/DonationAmountBanner'

const DonationPaymentStep = () => {
  const legalUrl = useDonationFormContext((state) => state.settings.legalUrl)

  return (
    <>
      <DonationStepTabs />
      <DonationAmountBanner />
      <DonationBackHeader title="Payment" withLockIcon={true} />
      <VStack w="100%">
        <PaymentButtons expressTitle="Express checkout" validateForm={false} />
        <TermsAndConditions legalUrl={legalUrl} />
      </VStack>
    </>
  )
}

export default DonationPaymentStep
